import React, { useEffect, useState } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import axios from 'axios';
import moment from 'moment'
import { env } from '../../config/index'
import { Row, Col, Typography, Breadcrumb, Form, Radio, Input, Button, Divider, Grid, Menu, Upload, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import PaymentConfirmation from './PaymentConfirmation';
import CheckStatus from './CheckStatus';
import Info from './Info';

const { useBreakpoint } = Grid;
const { Text } = Typography;

function Registration() {
  const [form] = Form.useForm();
  const [type, setType] = useState('PARTICIPANT');
  const [fileUploadFile, setFileUploadFile] = useState(null);
  const [submitLoading, setSubmitLoading] = useState(false);

  const { xs } = useBreakpoint()
  let location = useLocation()
  let history = useHistory()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  const handleMenu = (e) => {
    history.push(e.key)
  }

  const handleType = (e) => {
    setType(e.target.value)
    setFileUploadFile(null)
  }

  const handleUpload = () => {
    return {
      withCredentials: true,
      accept: type === 'ATLANTIS' ? ".doc,.docx" : ".pdf",
      beforeUpload: file => {
        const validateSize = type === 'ATLANTIS' ? file.size >= 10000000 : file.size >= 2000000;
        if (validateSize) {
          message.error(type === 'ATLANTIS' ? 'Max file size is 10 MB!' : 'Max file size is 2 MB!');
          return false
        }
        if (type !== 'ATLANTIS' && file.type !== 'application/pdf') {
          message.error('PDF file only');
          setFileUploadFile(null)
          return false
        }
        const index = file.name.lastIndexOf('.');
        const getExt = file.name.substring(index + 1) === 'doc' || file.name.substring(index + 1) === 'docx'
        if (type === 'ATLANTIS' && !getExt) {
          message.error('.doc or .docx file only');
          setFileUploadFile(null)
          return false
        }
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          setFileUploadFile(file)
          message.info('Upload Success!');
        }
        return false;
      },
    }
  }

  const handleRemove = (file) => {
    setFileUploadFile(null)
    message.success(`${file.name} file removed successfully`);
  }

  const onFinish = (values) => {
    if(fileUploadFile){
      values.fileUploadFile = fileUploadFile
    }
    if(values.country.toLowerCase().includes("indonesia")){
      if(moment().format('L') > moment('07/31/2024').format('L')){
        // reguler
        if(type === 'PARTICIPANT'){
          values.price = 150005
        }
        if(type === 'POSTER_PRESENTER'){
          values.price = 350005
        }
        if(type === 'PRESENTER_ORAL'){
          values.price = 500005
        }
        if(type === 'ATLANTIS'){
          values.price = 2500005
        }
      }else{
        // early bird
        if(type === 'PARTICIPANT'){
          values.price = 150005
        }
        if(type === 'POSTER_PRESENTER'){
          values.price = 200005
        }
        if(type === 'PRESENTER_ORAL'){
          values.price = 300005
        }
        if(type === 'ATLANTIS'){
          values.price = 2500005
        }
      }
    }else{
      if(type === 'ATLANTIS'){
        values.price = 200
      }else{
        values.price = 50
      }
    }

    const data = new FormData();
    for (const [val, name] of Object.entries(values)) {
      data.append(val, name);
    }
    
    if(type === 'POSTER_PRESENTER' && fileUploadFile === null){
      message.error('Abstract is required')
    }else{
      setSubmitLoading(true)
      setTimeout(() => {
        axios.post(`${env}/wchss/register`, data, {
          headers: {
            'Cache-Control': 'no-cache',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(response => {
          const { code } = response.data
          if(code === 1000){
            history.push({
              pathname: '/registration/success',
              state: response.data
            })
            setSubmitLoading(false)
          }else{
            message.error('General Error!')
            setSubmitLoading(false)
          }
        }).catch(error => {
          message.error(error.message)
          setSubmitLoading(false)
        })
      }, 500);
    }
  }

  const onFinishFailed = (errorInfo) => {
    message.error(errorInfo);
  }

  const items = [
    { label: 'Application', key: '/registration' },
    { label: 'Payment Confirmation', key: '/registration/payment-confirmation' },
    { label: 'Check Status', key: '/registration/check-status'},
    { label: 'Info & Payment Method', key: '/registration/info-and-payment-method' }
  ]

  return (
    <React.Fragment>
      <Row className='content-body' justify="space-around" align="middle" gutter={[8,8]} style={{ backgroundColor: '#fff' }}>
        <Col span={24} style={{ marginBottom: xs ? 16 : 32 }}>
          <Breadcrumb style={{ marginTop: xs ? 16 : -16 }}>
            <Breadcrumb.Item>
              <Link to="/">Home</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Registration</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        {
          xs ?
            <>
              <Col span={24}>
                <Text style={{ fontSize: 23, fontWeight: 'bold' }}>Registration</Text>
              </Col>
              <Col span={12}>
                <Link to="/registration">
                  {
                    location.pathname === '/registration' ?
                      <Button type="primary" block ghost>
                        Application
                      </Button>
                    :
                      <Button block>
                        Application
                      </Button>
                  }
                </Link>
              </Col>
              <Col span={12}>
                <Link to="/registration/payment-confirmation">
                  {
                    location.pathname === '/registration/payment-confirmation' ?
                      <Button type="primary" block ghost>
                        Payment Confirmation
                      </Button>
                    :
                      <Button block>
                        Payment Confirmation
                      </Button>
                  }
                </Link>
              </Col>
              <Col span={12}>
                <Link to="/registration/check-status">
                  {
                    location.pathname === '/registration/check-status' ?
                      <Button type="primary" block ghost>
                        Check Status
                      </Button>
                    :
                      <Button block>
                        Check Status
                      </Button>
                  }
                </Link>
              </Col>
              <Col span={12}>
                <Link to="/registration/info-and-payment-method">
                  {
                    location.pathname === '/registration/info-and-payment-method"' ?
                      <Button type="primary" block ghost>
                        Info & Payment Method
                      </Button>
                    :
                      <Button block>
                        Info & Payment Method
                      </Button>
                  }
                </Link>
              </Col>
            </>
          :
            <Col span={24}>
              <Text style={{ fontSize: 28, fontWeight: 'bold' }}>Registration</Text>
              <Menu 
                mode="horizontal" 
                defaultSelectedKeys={['/registration']}
                selectedKeys={location.pathname}
                items={items}
                onClick={handleMenu}
                style={{ marginTop: 32 }}
              />
            </Col>
            
        }
        <Col span={24}>
          {
            location.pathname === '/registration/payment-confirmation' ?
              <PaymentConfirmation />
            : location.pathname === '/registration/check-status' ?
              <CheckStatus />
            : location.pathname === '/registration/info-and-payment-method' ?
              <Info />
            :
              <Form
                layout="horizontal"
                form={form}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                labelCol={{ span: 5 }}
                wrapperCol={{ span: 16 }}
                style={{ marginTop: xs ? 8 : 32 }}
              >
                <Form.Item label="Registration Category" name="type" initialValue={type}>
                  <Radio.Group onChange={handleType}>
                    <Radio value="PARTICIPANT">Participant</Radio>
                    <Radio value="POSTER_PRESENTER">Presenter Poster</Radio>
                    <Radio value="PRESENTER_ORAL">Presenter Oral</Radio>
                    <Radio value="ATLANTIS">Atlantis</Radio>
                  </Radio.Group>
                </Form.Item>
                <Divider />
                <Form.Item name="firstName" label="First Name" rules={[{ required: true, message: 'This field is required' }]}>
                  <Input />
                </Form.Item>
                <Form.Item name="lastName" label="Last Name" rules={[{ required: true, message: 'This field is required' }]}>
                  <Input />
                </Form.Item>
                <Form.Item name="education" label="Highest Education Qualification" rules={[{ required: true, message: 'This field is required' }]}>
                  <Input />
                </Form.Item>
                <Form.Item name="university" label="University" rules={[{ required: true, message: 'This field is required' }]}>
                  <Input />
                </Form.Item>
                <Form.Item name="country" label="Country" rules={[{ required: true, message: 'This field is required' }]}>
                  <Input />
                </Form.Item>
                <Form.Item name="nationality" label="Nationality" rules={[{ required: true, message: 'This field is required' }]}>
                  <Input />
                </Form.Item>
                <Form.Item name="email" label="Email" rules={[{ required: true, message: 'This field is required' }, { type: 'email', message: 'Invalid Email' }]}>
                  <Input />
                </Form.Item>
                <Form.Item name="alternativeEmail" label="Alternative Email" initialValue={''} rules={[{ type: 'email', message: 'Invalid Email' }]}>
                  <Input />
                </Form.Item>
                <Form.Item name="mobileNumber" label="Mobile Number" rules={[{ required: true, message: 'This field is required' }]}>
                  <Input />
                </Form.Item>
                {
                  type === 'POSTER_PRESENTER' || type === 'PRESENTER_ORAL' || type === 'ATLANTIS' ?
                  <Form.Item name="titleAbstract" label="Title of the Abstract" initialValue={''} rules={[{ required: type === 'PRESENTER', message: 'This field is required' }]}>
                    <Input />
                  </Form.Item>
                  : null
                }
                {
                  type === 'POSTER_PRESENTER' || type === 'PRESENTER_ORAL' || type === 'ATLANTIS' ?
                    <Form.Item name="fileUploadFile" label={type === 'ATLANTIS' ? "Full Paper" : "Abstract"} tooltip={type === 'ATLANTIS' ? ".doc or .docx file only and Max. 10 MB" : "PDF file only and Max. 2 MB"}>
                      <Upload {...handleUpload()} maxCount={1} showUploadList={fileUploadFile} onRemove={handleRemove}>
                        <Button icon={<UploadOutlined />}>Click to Upload</Button>
                      </Upload>
                    </Form.Item>
                  :
                    null
                }
                <Form.Item wrapperCol={ xs ? {span: 24} : { span: 16, offset: 5 } }>
                  <Button type="primary" htmlType='submit' block loading={submitLoading}>Register</Button>
                </Form.Item>
              </Form>
          }
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default Registration